/* eslint-disable */
import * as icon from 'vue-svgicon'
icon.register({
  'tag': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M22.256 12.354a1.386 1.386 0 0 0-.854-.354h-8.898a.505.505 0 0 0-.504.5v8.899c0 .274.161.659.355.853l13.391 13.39a.504.504 0 0 0 .707 0l9.193-9.193a.503.503 0 0 0 0-.707l-13.39-13.388zm-3.842 6.06a2 2 0 1 1-2.828-2.828 2 2 0 0 1 2.828 2.828z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/tag.js